import React from "react";
import styles from "./Button.module.scss";

export default function Button({
  className,
  title,
  titleClassName,
  onClick,
  leftIcon,
  disabled,
}) {
  return (
    <div
      className={`${styles.container} ${className} ${
        disabled ? styles.disabled : ""
      }`}
      onClick={onClick}
    >
      {leftIcon}
      {title && (
        <p
          style={{ marginLeft: leftIcon ? "10px" : "0" }}
          className={`${styles.title} ${titleClassName}`}
        >
          {title}
        </p>
      )}
    </div>
  );
}
